import React, { createContext, useState, useEffect } from 'react';

export const CmContext = createContext();

const HOST = "https://linetx.z.ufaprimo.com";
// const HOST = "localhost:5000";


export function CmProvider({ children }) {
    const [containers, setContainers] = useState([]);
    const [loading, setLoading] = useState("");
    
    useEffect(() => {
        reload(false);    
    }, [])

    async function reload(force) {
        setLoading("status");
        const resp = await fetch(`${HOST}/api/containers/status?force=${force?"true":"false"}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });


        if (resp.ok) {
            const data = await resp.json();
            setContainers(data.sort((a, b) => {
                return a.name.localeCompare(b.name)
            }));
        }
        setLoading("");
    }

    async function restart(party, account_no) {
        setLoading(`restart-${account_no}`);
        const resp = await fetch(`${HOST}/api/containers/restart/${party}/${account_no}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },  
            body: JSON.stringify({}),
        })

        if (resp.ok) {
            // const data = await resp.json();
            // console.log(data)
        }
        setLoading("");

        setTimeout(() => {
            reload(true);
        }, 5000)
    }
    async function rebuild() {
        setLoading(`rebuild`);
        const resp = await fetch(`${HOST}/api/containers/refresh`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },  
            body: JSON.stringify({}),
        })

        if (resp.ok) {
            const data = await resp.json();
            console.log(data)
        }
        setLoading("");
        setTimeout(() => {
            reload(true);
        }, 5000)

    }


    return (
        <CmContext.Provider value={{
            containers, 
            reload,
            loading,
            restart,
            rebuild,
        }}> 
            {children}
        </CmContext.Provider>
    );
};

export function useCm() {
  return React.useContext(CmContext);
}
